import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { cfgCaseProcedure4Procedure } from '../../procedure/creation/procedure-creation.models';
import {CaseProcedureConfigurationModel} from '../../../models/caseProcedures/case-procedure-configuration.model';
import {
  CaseProcedureAdaCodeConfigurationModel
} from "../../../models/caseProcedures/case-procedure-ada-code-configuration.model";
import {FormDeleteResponseModel} from '../../../models/forms/form-delete-response.model';
import { cfgCaseProcedure } from '../../ar/_models/ar.models';

export interface ProcedureFormListItem {
  DFormName: string;
  DFormId: string;
  enumFormCategoryID: string;
  ItemDisplayValue: string;
  Version: string;
  Status: string;
}

@Injectable({
  providedIn: 'root'
})

// TODO: Why do we have a ProcedureService and a ProceduresService???
export class ProceduresService {
  constructor(private http: HttpClient) { }

  getApplicationProcedures(): Observable<CaseProcedureConfigurationModel[]> {
    return this.http.get<CaseProcedureConfigurationModel[]>(`/api/Procedures`);
  }

  getClientProcedures(TDOCID: string): Observable<CaseProcedureConfigurationModel[]> {
    return this.http.get<CaseProcedureConfigurationModel[]>(`api/get-procedures-for-client/${TDOCID}`);
  }

  getProcedureGroupInfo(procedureID: string): Observable<any> {
    return this.http.get<any>(`/api/Procedures/${procedureID}/GroupInfo`);
  }

  createProcedure(procedure: any): Observable<CaseProcedureConfigurationModel> {
    return this.http.post<CaseProcedureConfigurationModel>(`/api/procedure`, procedure);
  }

  updateProcedures(procedureID: string, procedure: any): Observable<any> {
    return this.http.post<any>(`/api/procedure/${procedureID}`, procedure);
  }

  deleteProcedure(procedureId: string) {
    return this.http.get<CaseProcedureConfigurationModel>(`api/procedure/delete-procedure/${procedureId}`);
  }

  getForms(): Observable<ProcedureFormListItem[]> {
    return this.http.get<ProcedureFormListItem[]>(`/api/forms/getProceduresFormList`);
  }

  deleteProcedureForm(id: string): Observable<void> {
    return this.http.get<void>(`api/procedure/delete-procedure-form/${id}`);
  }

  deleteProcedureFormsByDFormId(id: string): Observable<void> {
    return this.http.get<void>(`api/procedure/delete-procedure-forms-by-dformid/${id}`);
  }

  changeChildOrder(procedures: string[]) {
    return this.http.post<void>('api/procedure/change-child-order', procedures);
  }

  convertToAdaCodes() {
    return this.http.get<void>(`api/patient-cases/convert-procedure-codes-to-ada`);
  }

  deleteAdaCode(CaseProcedureCodeId: string) {
    return this.http.get<void>(`api/patient-cases/delete-ada-code/${CaseProcedureCodeId}`);
  }

  addAdaCode(id: string, codeInput: string) {
    return this.http.get<CaseProcedureAdaCodeConfigurationModel>(`api/patient-cases/add-ada-code/${id}/${codeInput }`);
  }

  swapFormForProcedures(DFormId: string, newId: string) {
    return this.http.get<void>(`api/procedure/swap-procedure-forms/${DFormId}/${newId}`);
  }

  checkProcedureFormsIntegrity() {
    return this.http.get<FormDeleteResponseModel>(`api/procedure/check-forms-integrity`);
  }

  createProcedureCode(code: string, doctorId: string, patientId: string, procedure: cfgCaseProcedure) {
    return this.http.post(`api/procedure/code/${code}/${doctorId}/${patientId}`, procedure);
  }
}
